// 每日小時成本
import * as types from '../actionType';

let initState = {
};

function HourCostChart(state = initState, action) {
  switch (action.type) {
      case types.HOUR_COST_CHART_SUCCESS:{
        return action.result;
      }
      default:
        return state;
  }
}

export default HourCostChart;
